import { adminBaseQueryWrapper } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";

export const adjustStockApi = createApi({
  reducerPath: "adjustStockApi",
  baseQuery: adminBaseQueryWrapper,
  tagTypes: ["adjustStock"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    createAdjustStock: builder.mutation<void, any>({
      query: (input) => ({
        url: `/adjust-stock`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["adjustStock"],
    }),
    getByPurchaseId: builder.query<any, any>({
      query: ({ id }) => `/adjust-stock/adjustments/${id}`,
      providesTags: ["adjustStock"],
    }),
    updateStockAdjust: builder.mutation<void, any>({
      query: ({ id, data }) => ({
        url: `/adjust-stock/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["adjustStock"],
    }),
  }),
});

export const {
  useCreateAdjustStockMutation,
  useGetByPurchaseIdQuery,
  useUpdateStockAdjustMutation,
} = adjustStockApi;
